import isNil from 'lodash/isNil';

import type { AppData } from '../../types/app_data';
import { StepCategory } from '../../types/app_data';
import type { Step } from '../types/step';

export const ClaimsOnboardingStep: Step = {
  // Ask if user had any claims
  id: 'askClaims',
  pathname: '/claims',
  excludeFromProgressCalculation: true,
  canShow: (appData: AppData) => {
    if (!appData.selectedService?.insurance) {
      return false;
    }

    if (appData.signupParams?.needNNOInsurance === true) {
      return false;
    }

    return (
      !appData.isOnboardingLite &&
      !appData.featureData?.askICVBeforeOnboarding &&
      !(appData.signupParams?.partnerSignup && !isNil(appData.partnerSkippableData?.claims))
    );
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => !isNil(appData.signupParams?.claims),
  category: () => StepCategory.Insurance,
};
